import React from 'react';

const EventHeader = () => {
  return (
    <section className="relative h-[500px] overflow-hidden rounded-lg">
      {/* Background image */}
      <div className="absolute inset-0 z-0 rounded-lg">
        <div 
          className="w-full h-full bg-cover bg-center rounded-lg"
          style={{ backgroundImage: "url('/event-single/bg.png')" }}
        ></div>
      </div>

      <div className="container mx-auto h-full relative z-10">
        <div className="h-full flex items-center">
          <div className="max-w-xl px-4">
            {/* Date and Location */}
            <div className="flex flex-wrap gap-4 mb-5">
              <div className="flex items-center text-white">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span className="ml-2 text-sm">6 April, 2022</span>
              </div>

              <div className="flex items-center text-white">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="ml-2 text-sm">London, UK</span>
              </div>
            </div>

            {/* Title */}
            <h1 className="text-[40px] font-bold text-white mb-3">
              Build Education Website Using WordPress
            </h1>

            {/* Countdown */}
            <div className="flex gap-8 md:gap-12">
              <div className="text-white">
                <div className="text-[40px] font-bold">20</div>
                <div className="text-sm">Days</div>
              </div>

              <div className="text-white">
                <div className="text-[40px] font-bold">32</div>
                <div className="text-sm">Hours</div>
              </div>

              <div className="text-white">
                <div className="text-[40px] font-bold">57</div>
                <div className="text-sm">Minutes</div>
              </div>

              <div className="text-white">
                <div className="text-[40px] font-bold">13</div>
                <div className="text-sm">Seconds</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventHeader;